import { createApi } from '@reduxjs/toolkit/query/react';
import { HandoverComment, HandoverCommentResponse } from '@handover/shared-types';
import { HANDOVER_COMMENT_END_POINTS, METHOD } from '../../constants/constant';
import { customHandoverBaseQuery } from '../customBaseQuery';

export const handoverCommentApi = createApi({
  reducerPath: 'commentApi',
  baseQuery: customHandoverBaseQuery,
  keepUnusedDataFor: 300, // Keep data in cache for 5 minutes
  refetchOnMountOrArgChange: 30, // Refetch if data is older than 30 seconds
  refetchOnFocus: false, // Disable refetch on focus to reduce API calls
  refetchOnReconnect: true,
  tagTypes: ['Comments'],
  endpoints: builder => ({
    // Fetch comments for a specific handover ID
    getHandoverCommentsByHandoverId: builder.query<HandoverCommentResponse, string>({
      query: handoverId => ({
        url: HANDOVER_COMMENT_END_POINTS.gethandovercommentdocbyhandoverid.replace(':handoverId', handoverId),
        method: METHOD.GET,
      }),
      providesTags: ['Comments'],
      keepUnusedDataFor: 300, // Keep data for 5 minutes
    }),
    // Update or create a new comment for a handover
    updateHandoverComment: builder.mutation<HandoverComment, { handoverId: string; commentData: HandoverComment }>({
      query: ({ handoverId, commentData }) => ({
        url: HANDOVER_COMMENT_END_POINTS.updatehandovercomment.replace(':handoverId', handoverId),
        method: METHOD.PUT,
        body: commentData,
      }),
      invalidatesTags: ['Comments'],
    }),
    // Delete a comment from a handover
    deleteHandoverComment: builder.mutation<void, { handoverId: string; commentData: HandoverComment }>({
      query: ({ handoverId, commentData }) => ({
        url: HANDOVER_COMMENT_END_POINTS.deletehandovercomment.replace(':handoverId', handoverId),
        method: METHOD.DELETE,
        body: commentData,
      }),
      invalidatesTags: ['Comments'],
    }),
  }),
});

export const {
  useGetHandoverCommentsByHandoverIdQuery,
  useUpdateHandoverCommentMutation,
  useDeleteHandoverCommentMutation,
} = handoverCommentApi;
